export const root = '/upgrade';

export const choice = `${root}/choice`;
export const confirm = `${root}/confirm`;
export const featurePreview = `${root}/feature-preview/:featureName`;
